'use client';

import { CONNECT_DUPR_MODAL_KEY, DEFAULT_EXPIRATION } from './constants';

export const getShouldShowModal = (userConnectedDUPR: boolean) => {
	if (userConnectedDUPR) {
		deleteShouldShowModal();
		return false;
	}

	const itemStr = localStorage.getItem(CONNECT_DUPR_MODAL_KEY);

	if (!itemStr) {
		return true;
	}

	try {
		const item = JSON.parse(itemStr);

		const now = new Date();

		if (item.expiry < now.getTime()) {
			return true;
		}

		return false;
	} catch {
		setShouldShowModal();
		return true;
	}
};

export const setShouldShowModal = (expiresIn = DEFAULT_EXPIRATION) => {
	const now = new Date();

	const item = {
		value: 'true',
		expiry: now.getTime() + expiresIn
	};

	localStorage.setItem(CONNECT_DUPR_MODAL_KEY, JSON.stringify(item));
};

const deleteShouldShowModal = () => {
	localStorage.removeItem(CONNECT_DUPR_MODAL_KEY);
};
